/* eslint-disable */
export const RACE_CIRCUITS = {
  REGIONAL: {
    id: 'regional',
    name: 'Regional Circuit',
    description: 'Local races within your home region',
    entryFee: 2000,
    xpMultiplier: 1.0,
    rewardMultiplier: 1.0,
    unlockLevel: 1,
    getEligibleRegions: (homeRegion, isPlayer) => {
      // Players can enter any chocobo into regional races
      if (isPlayer) {
        return ['region1', 'region2', 'region3', 'region4', 'region5', 'region6']
      }
      // NPCs limited to home region
      return [homeRegion]
    }

  },
  CONTINENTAL: {
    id: 'continental',
    name: 'Continental Circuit',
    description: 'Races across your home continent',
    entryFee: 4000,
    xpMultiplier: 1.2,
    rewardMultiplier: 2.0,
    unlockLevel: 10,
    getEligibleRegions: (homeRegion) => {
      const continentMapping = {
        eastern: ['region1', 'region2'],
        western: ['region3', 'region4'],
        mideel: ['region5'],
        northern: ['region6']
      }

      
      const continent = Object.entries(continentMapping)
        .find(([_, regions]) => regions.includes(homeRegion))?.[0]
      return continent ? continentMapping[continent] : [homeRegion]
    }
  },
  TRANS_CONTINENTAL: {
    id: 'transcontinental',
    name: 'Trans-Continental Racing',
    description: 'High-stakes races between continents',
    entryFee: 6000,
    xpMultiplier: 1.3,
    rewardMultiplier: 3.0,
    unlockLevel: 20,
    getEligibleRegions: () => {
      return ['region1', 'region2', 'region3', 'region4', 'region5', 'region6', 'region7']
    }
  },
  GLOBAL: {
    id: 'global',
    name: 'Global Circuit',
    description: 'Elite worldwide racing competition',
    entryFee: 25000,
    xpMultiplier: 1.5,
    rewardMultiplier: 10.0,
    unlockLevel: 30,
    getEligibleRegions: () => {
      return ['region1', 'region2', 'region3', 'region4', 'region5', 'region6', 'region7']
    }
  },
  SAUCER: {
    id: 'saucer',
    name: 'Gold Saucer Circuit',
    description: 'The most prestigious racing competition in the world',
    entryFee: 40000,
    xpMultiplier: 1.8,
    rewardMultiplier: 25.0,
    unlockLevel: 40,
    getEligibleRegions: () => {
      return ['region1', 'region2', 'region3', 'region4', 'region5', 'region6', 'saucer', 'region7']
    }
  }
}

export const getAvailableCircuits = (playerLevel, homeRegion) => {
  return Object.values(RACE_CIRCUITS)
    .filter(circuit => playerLevel >= circuit.unlockLevel)
    .map(circuit => ({
      ...circuit,
      eligibleRegions: circuit.getEligibleRegions(homeRegion)
    }))
}
export const getCircuitName = (id) => {
  const circuit = RACE_CIRCUITS[id];
  return circuit ? circuit.name : 'Unknown';
};
